/**
 * @format
 * @flow
 */
import React from 'react';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
// eslint-disable-next-line import/no-extraneous-dependencies
import { withRouter } from 'react-router';
import Modal from '../../../components/Common/Modal';
import * as Actions from '../../../actions/Task';
import Template from '../../../components/Template/AfterLoginTemplate';
import TaskCard from '../../../components/Parts/TaskCard';
import { Link } from 'react-router-dom';
import * as RT from '../../../constants/Routing';
import ReactTable from 'react-table-v6';
import 'react-table-v6/react-table.css';
import DateJp from 'UltraDate.js';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import * as CONST from '../../../constants/Const';

DateJp.setDefaultLocale('ja');

class Component extends React.Component {
  constructor(props) {
    super(props);
    console.log('TCL: Component -> constructor -> props', props);

    this.state = {
      loaded: false,
      tasks: this.props.Task.currentTask.Items,
      status: this.props.Task.searchArgs.status,
      formErrors: { enterpriseId: '' },
      date: this.props.Task.searchArgs.searchDate,
      title: this.props.Task.searchArgs.title,
      isCalendar: false,
      enterpriseId: this.props.Task.searchArgs.enterpriseId,
      taskCategoryId: this.props.Task.searchArgs.taskCategoryId,
      license1: this.props.Task.searchArgs.license1,
      taskStatus: this.props.Task.searchArgs.taskStatus,
      page: this.props.Task.searchArgs.page,
      isSearch: false
    };
    this.currentUser = JSON.parse(localStorage.getItem('current_user'));
  }

  componentWillMount = () => {
    const { accessToken } = this.currentUser;
    this.getTask(this.props.Task.searchArgs.status, this.props.Task.searchArgs.page);
    this.props.getCategories(accessToken);
    this.props.getLicensesInTask(accessToken);
    console.log("TCL: Component -> componentWillMount -> '現在のタスク'", this.props);
  };

  componentWillReceiveProps = next => {
    if (!this.state.loaded && next.Task.currentTaskLoaded !== this.state.loaded) {
      this.setState({ loaded: true });
    }
    if (!this.state.loaded && next.Task.oldTaskLoaded !== this.state.loaded) {
      this.setState({ loaded: true });
    }
  };

  componentWillUnmount = () => {
    switch (this.state.status) {
      case '現在のタスク':
        this.props.resetCurrentTasks();
        break;
      case '過去のタスク':
        this.props.resetOldTasks();
        break;
      default:
        break;
    }
  };

  getTask = (status, page) => {
    const token = this.currentUser.accessToken;
    const { enterpriseId } = this.currentUser;
    switch (status) {
      case '現在のタスク':
        this.props.getCurrentTask(this._genSearchParams(), token, page, 10);
        break;
      case '過去のタスク':
        this.props.getOldTask(this._genSearchParams(), token, page, 10);
        break;
      default:
        break;
    }
  };

  _toPaging = page => {
    this.setState({ page }, () => {
      this.getTask(this.state.status, page);
      var data = this._genSearchParams();
      this.props.saveTaskStatus({ ...data });
    });
  };

  // eslint-disable-next-line consistent-return
  _renderPaging = () => {
    const { status } = this.state;
    const pageCount =
      status === '現在のタスク'
        ? this.props.Task.currentTask.page_count
        : this.props.Task.oldTask.page_count;
    if (pageCount > 1) {
      const nextPage =
        status === '現在のタスク'
          ? this.props.Task.currentTask.next_pages
          : this.props.Task.oldTask.next_pages;
      const prevPage =
        status === '現在のタスク'
          ? this.props.Task.currentTask.prev_pages
          : this.props.Task.oldTask.prev_pages;
      const currentPage =
        status === '現在のタスク'
          ? this.props.Task.currentTask.next_pages - 1
          : this.props.Task.oldTask.next_pages - 1;

      const pageList = [...Array(pageCount)].map((_, i) => {
        const isActivePage = currentPage === i + 1 || (nextPage === 0 && i + 1 === pageCount);
        const classList = isActivePage ? 'active page-item' : 'page-item';

        let action;
        if (!isActivePage) {
          action = () => this._toPaging(i + 1);
        }

        return (
          <li className={classList}>
            <span className="page-link" onClick={action}>
              {i + 1}
            </span>
          </li>
        );
      });

      let prevAction;
      if (prevPage !== 0) {
        prevAction = () => this._toPaging(prevPage);
      }

      let nextAction;
      if (nextPage !== 0) {
        nextAction = () => this._toPaging(nextPage);
      }

      return (
        <div className="paging-wrap">
          <ul className="pagination">
            <li className="page-item">
              <span className="page-link prev-link" onClick={prevAction}>
                «
              </span>
            </li>
            {pageList}
            <li className="page-item">
              <span className="page-link next-link" onClick={nextAction}>
                »
              </span>
            </li>
          </ul>
        </div>
      );
    }
  };

  _validateField = (fieldName, value) => {
    // eslint-disable-next-line react/destructuring-assignment
    const { formErrors, enterpriseId } = this.state;
    let { enterpriseIdValid } = this.state;
    switch (fieldName) {
      case 'enterpriseId':
        enterpriseIdValid = !!enterpriseId;
        formErrors.enterpriseId = enterpriseIdValid
          ? enterpriseId.length <= 10
            ? ('施設IDは11文字でなければなりません', (enterpriseIdValid = false))
            : ''
          : '施設IDを入力してください。';
        break;
      default:
        break;
    }
    this.setState({ formErrors, enterpriseIdValid }, this._validateForm);
  };

  _renderTaskItems = () => {
    const { status } = this.state;
    const items =
      status === '現在のタスク' ? this.props.Task.currentTask.Items : this.props.Task.oldTask.Items;
    if (items !== null && items.constructor === Array && items.length > 0) {
      return items.map(item => {
        return (
          <tr>
            <td>
              <div
                className="task-icon task-icon-in-detail"
                style={{ backgroundImage: `url(${item.taskPhotoId})` }}
              ></div>
            </td>
            <td>
              {item.taskId}
              <br />
              {item.title}
            </td>
            <td>
              <Link className="btn btn-primary btn-md task-btn ">
                {item.taskCategoryDetail[0].value.replace(/,/g, '')}
              </Link>
            </td>
            <td>
              {item.startDate}-{new DateJp(item.endDate).format('MM/dd')}
              <br />
              {item.startTime}-{item.endTime}
            </td>
            <td>
              {item.licenseDetail.length > 0
                ? Array.prototype.map
                  .call(item.licenseDetail, function (item) {
                    return item.value;
                  })
                  .join('/')
                : 'なし'}
            </td>
            <td>{String(item.fee).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')}</td>
            <td>-</td>
            <td>{item.participant.length}人</td>
            <td>{item.taskStatus}</td>
            <td>
              <Link
                className="btn btn-primary btn-md task-btn"
                to={RT.TASK_SHOW_PATH.replace(/:task_id/, item.taskId)}
              >
                タスク詳細へ
              </Link>
            </td>
          </tr>
        );
      });
    }
    return (
      <tr>
        <td colSpan="6">請求対象となる実施済みのタスクがありません。</td>
      </tr>
    );
  };

  _setValue = e => {
    if (e.target.name === 'status') {
      this.setState({ [e.target.name]: e.target.value }, () => {
        var data = this._genSearchParams();
        const returnedTarget = Object.assign(data, { page: 1 });
        console.log('TCL: returnedTarget', returnedTarget);
        this.props.saveTaskStatus({ ...returnedTarget });
        this.getTask(this.state.status, 1);
      });
    }
    this.fillValue(e.target.name, e.target.value);
  };

  fillValue(name, value) {
    this.setState({ [name]: value }, () => {
      this._validateField(name, value);
    });
  }

  _errorClass = error => {
    return error.length === 0 ? '' : 'has-error';
  };

  _renderLicensesSelect = () => {
    return (
      <div className="">
        <select
          className="form-select mb-2"
          name="license1"
          id=""
          onChange={this._setValue}
          defaultValue={this.state.license1}
        >
          <option value="" key="0" />
          {this._renderLicensesOptions(0)}
        </select>
      </div>
    );
  };

  _renderLicensesOptions = index => {
    const { licenses } = this.props.Task;
    return licenses.map((item, i) => {
      return (
        <option value={item.key} key={item.key}>
          {item.value}
        </option>
      );
    });
  };

  _renderTaskCategoriesOptions = () => {
    return this.props.Task.categories.map(cat => {
      return (
        <option value={cat.categoryId} key={cat.categoryId}>
          {cat.categoryName}
        </option>
      );
    });
  };

  onChange = date => this.setState({ date });

  renderColumn = () => {
    return [
      {
        // Header: props => <div>
        //     ID<span className="fa fa-sort"></span></div>,
        width: 80,
        accessor: 'taskId', // String-based value accessors!
        Cell: props => (
          <div
            className="task-icon task-icon-in-detail"
            style={{ backgroundImage: `url(${props.original.taskPhotoId})` }}
          ></div>
        )
      },
      {
        width: 200,
        Header: props => (
          <div>
            タスク名<span className="fa fa-sort"></span>
          </div>
        ),
        accessor: 'taskId',
        Cell: props => (
          <span>
            {' '}
            {props.original.taskId}
            <br />
            {props.original.title}
          </span>
        )
      },
      {
        Header: props => (
          <div>
            カテゴリ<span className="fa fa-sort"></span>
          </div>
        ),
        accessor: '業務内容',
        Cell: props => (
          <Link className=" ">{props.original.taskCategoryDetail[0].value.replace(/,/g, '')}</Link>
        )
      },
      {
        Header: props => (
          <div>
            日時<span className="fa fa-sort"></span>
          </div>
        ),
        accessor: '期間', // Custom value accessors!
        Cell: props => (
          <span>
            {' '}
            {props.original.startDate}-{new DateJp(props.original.endDate).format('MM/dd')}
            <br />
            {props.original.startTime}-{props.original.endTime}
          </span>
        )
      },
      {
        Header: props => (
          <div>
            必須資格<span className="fa fa-sort"></span>
          </div>
        ),
        accessor: '必須資格',
        Cell: props => {
          var skills =
            props.original.licenseDetail.length > 0
              ? Array.prototype.map
                .call(props.original.licenseDetail, function (item) {
                  return item.value;
                })
                .join('/')
              : 'なし';
          return <span value={skills}>{skills}</span>;
        }
      },
      {
        Header: props => (
          <div>
            報酬<span className="fa fa-sort"></span>
          </div>
        ),
        accessor: 'fee',
        Cell: props => (
          <span> {String(props.original.fee).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')}</span>
        )
      },
      {
        Header: props => (
          <div>
            募集数<span className="fa fa-sort"></span>
          </div>
        ),
        accessor: '', // Custom value accessors!
        Cell: props => <span> {'1人'} </span>
      },
      {
        Header: props => (
          <div>
            応募数<span className="fa fa-sort"></span>
          </div>
        ),
        accessor: 'participant', // Custom value accessors!
        Cell: props => (
          <span value={props.original.participant.length}>
            {props.original.participant.length}人
          </span>
        )
      },
      {
        Header: props => (
          <div>
            承認数<span className="fa fa-sort"></span>
          </div>
        ),
        accessor: 'approvedCount', // Custom value accessors!
        Cell: props => (
          <span value={props.original.approvedCount}> {props.original.approvedCount}人</span>
        )
      },
      {
        Header: props => (
          <div>
            完了数<span className="fa fa-sort"></span>
          </div>
        ),
        accessor: 'completedCount', // Custom value accessors!
        Cell: props => (
          <span value={props.original.completedCount}> {props.original.completedCount}人</span>
        )
      },
      {
        Header: props => (
          <div>
            ステータス<span className="fa fa-sort"></span>
          </div>
        ),
        accessor: 'taskStatus', // Custom value accessors!
        Cell: props => {
          const taskEndDateTime = new Date(`${props.original.endDate} ${props.original.endTime}`);
          const canDoReview =
            props.original.taskStatusDetail.key === CONST.TS_APPROVED &&
            taskEndDateTime < new Date();
          const noApproved =
            props.original.taskStatusDetail.key === CONST.TS_CREATE &&
            props.original.participant.length >= 0 &&
            taskEndDateTime < new Date();
          console.log(
            'TCL: renderColumn -> props.original.participant.key',
            props.original.taskStatusDetail.key,
            taskEndDateTime,
            canDoReview,
            props.original.taskId
          );
          return canDoReview ? 'レビュー待ち' : noApproved ? '募集終了' : props.original.taskStatus;
        }
      },
      {
        Header: rops => <span></span>,
        accessor: '', // Custom value accessors!
        Cell: props => (
          <span>
            {' '}
            <Link className="" to={RT.TASK_SHOW_PATH.replace(/:task_id/, props.original.taskId)}>
              詳 細
            </Link>
          </span>
        )
      }
    ];
  };

  _genSearchParams = () => {
    const args = {};

    if (this.state.title) {
      args.title = this.state.title;
    }
    if (this.state.date && this.state.date[0] !== 0) {
      args.searchDate = this.state.date;
    }
    if (this.state.taskStatus) {
      args.taskStatus = this.state.taskStatus;
    }
    if (this.state.taskCategoryId) {
      args.taskCategoryId = this.state.taskCategoryId.split(',').map(x => {
        return Number(x);
      });
    }
    if (this.state.license1) {
      args.licenseId = this.state.license1.split(',').map(x => {
        return Number(x);
      });
    }
    args.enterpriseId = this.currentUser.enterpriseId;
    args.status = this.state.status;
    args.page = this.state.page;
    console.log('TCL: Component -> _genSearchParams -> args', args);
    return args;
  };

  search = async () => {
    var data = this._genSearchParams();
    const returnedTarget = Object.assign(data, { page: 1 });
    console.log('TCL: returnedTarget', returnedTarget);
    await this.props.saveTaskStatus({ ...returnedTarget });
    this.getTask(this.state.status, 1);
  };

  render = () => {
    // console.log(this.props)
    const { status } = this.state;
    const { enterpriseId } = this.currentUser;
    const { formErrors } = this.state;
    const tasks =
      status === '現在のタスク' ? this.props.Task.currentTask.Items : this.props.Task.oldTask.Items;

    return (
      <Template>
        <Modal
          isOpen={this.props.App.modalOpen}
          closeModal={this.props.modalCloseInAuth}
          headerTitle={this.props.App.modalHeader}
          // eslint-disable-next-line no-console
          okClickHandler={() => console.log('aaa')}
          okText="ログインページへ"
          okBtnClass="btn btn-primary"
        >
          {this.props.App.modalText}
        </Modal>
        <h2 className="title">タスク管理</h2>
        <div className="subtitle-block">
          <h3 className="sub-title">
            現在、過去の全てのタスクを管理します。タスク検索から表示条件を変更できます。
          </h3>
          <Link to={RT.TASK_NEW_PATH}>
            新規タスクを登録する
          </Link>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="search-wrap">
              <h3 onClick={() => this.setState({ isSearch: !this.state.isSearch })}>
                <i class={!this.state.isSearch ? 'fas fa-plus' : 'fas fa-minus'}></i>
                <span>タスク検索</span>
              </h3>
              {this.state.isSearch && (
                <div className="form-row">
                  <div className="col-sm-1">
                    <label htmlFor="">施設ID</label>
                    <input
                      type="text"
                      className={`form-control ${this._errorClass(formErrors.enterpriseId)}`}
                      id="enterpriseId"
                      name="enterpriseId"
                      placeholder=""
                      value={enterpriseId}
                      onChange={this._setValue}
                    />
                    <label className="error_text">{formErrors.enterpriseId}</label>
                  </div>
                  <div className="col-sm-2">
                    <label htmlFor="">タスク名</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder=""
                      id="title"
                      name="title"
                      defaultValue={this.state.title}
                      onChange={this._setValue}
                    />
                  </div>
                  <div className="col-sm-3 datepicker-block">
                    <label htmlFor="exampleInputPassword1">日時</label>
                    <DateRangePicker
                      // clearIcon={null}
                      onChange={this.onChange}
                      value={this.state.date}
                    />
                  </div>
                  <div className="col-sm-2">
                    <label htmlFor="exampleInputPassword1">必要な資格</label>
                    <br />
                    {(() => {
                      if (this.state.licenseDuplicated) {
                        return (
                          <div className="alert alert-danger" role="alert">
                            必要な資格が重複しています。
                          </div>
                        );
                      }
                    })()}
                    {this._renderLicensesSelect()}
                  </div>
                  <div className="col-sm-2">
                    <label htmlFor="">ステータス</label>
                    <div>
                      <select
                        className="form-select"
                        name="taskStatus"
                        id="taskStatus"
                        onChange={this._setValue}
                        defaultValue={this.state.taskStatus}
                      >
                        <option value="" key="0" />
                        <option value="0" key="1">
                          募集中
                        </option>
                        <option value="1" key="2">
                          募集停止中
                        </option>
                        <option value="2" key="3">
                          募集終了
                        </option>
                        <option value="3" key="4">
                          タスクルーのレビュー待ち
                        </option>
                        <option value="4" key="5">
                          完了
                        </option>
                      </select>
                    </div>
                  </div>
                  <div className="col-sm-2">
                    <label htmlFor="exampleInputPassword1">業務内容</label>
                    <br />
                    <select
                      className="form-select"
                      name="taskCategoryId"
                      id=""
                      onChange={this._setValue}
                      defaultValue={this.state.taskCategoryId}
                    >
                      <option value="" key="0" />
                      {this._renderTaskCategoriesOptions()}
                    </select>
                  </div>
                  <div className="col-sm-12 task-management-button">
                    <button type="submit" onClick={this.search} className="btn">
                      検<span>索</span>
                    </button>
                  </div>
                </div>
              )}
            </div>
            <div className="task-top-block">
              <h2>タスク一覧</h2>
              <div className="task-select-in-headline">
                <select
                  className=""
                  name="status"
                  id="status"
                  onChange={this._setValue}
                  defaultValue={this.state.status}
                >
                  <option value="現在のタスク" key="1">
                    現在のタスク
                  </option>
                  <option value="過去のタスク" key="2">
                    過去のタスク
                  </option>
                </select>
              </div>
            </div>
            <div className="task-block table-responsive">
              {tasks !== undefined && tasks.length > 0 && (
                <ReactTable
                  className="table table-common"
                  data={
                    this.state.status === '現在のタスク'
                      ? this.props.Task.currentTask.Items
                      : this.props.Task.oldTask.Items
                  }
                  columns={this.renderColumn()}
                  minRows={
                    this.state.status === '現在のタスク'
                      ? this.props.Task.currentTask.Items.length
                      : this.props.Task.oldTask.Items.length
                  }
                  showPagination={false}
                />
              )}
            </div>
            {(() => {
              if (this.state.loaded) {
                return this._renderPaging();
              }
            })()}
          </div>
        </div>
      </Template>
    );
  };
}

const mapStateToProps = state => state;
const mapDispatchToProps = dispatch => bindActionCreators(Actions, dispatch);

const Container = connect(mapStateToProps, mapDispatchToProps)(Component);

export default withRouter(Container);
